import axios from "axios";
let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "";
export default {
  state: {
   userDetails: {}
  },
  getters: {
    getUserDetails: (state) => state.userDetails
  },
  actions: {
    fetchUserDetails({ commit, dispatch} , trackPayload) {
      axios.get(`${BASE_URL}/auth/user`).then((response) => {
        commit("setUserDetails",response.data.user)
        dispatch('addUserTrack', trackPayload)
      });
    },
    addUserTrack({}, trackPayload){
      axios.post(`${BASE_URL}/auth/userTrack`,trackPayload).then(response => {})
    }
  },
  mutations: {
    setUserDetails: (state, userData) => (state.userDetails = userData),
  },
};
